import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const CgbIconRowBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={`icon-list ${props.attributes.className ? props.attributes.className : ''} ${classes.iconRow} ${classes.iconRowTheme}`}>
        {blocks.map((block) => {
            return block;
        })}
    </div>
};

export const CgbIconRowBlockFragment = graphql`
  fragment CgbIconRowBlock on WpBlock {
    ... on WpCgbIconRowBlock {
        name
        attributes {
            className
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbIconRowBlockPreview = `
    ... on CgbIconRowBlock {
        name
        attributes {
            className
        }
    }
`;